import React from 'react';
import compose from 'recompose/compose';
import { get, capitalize } from 'lodash';
import { bool, shape } from 'prop-types';
import { useIntl } from 'react-intl';
import {
  Grid,
  Typography,
  withStyles,
} from '@material-ui/core';

import { getI18nFormattedMessage, getI18n } from '../../../../utils/intl';
import { formatNumber } from '../../../../utils';
import {
  Footer,
} from '../../../../components';
import styles from './styles';
import { DISTRIBUTED_RATE_LIMIT_INTERVAL_API } from "../../../../constants";
import { getFeatureFlagForDistributeRateLimit } from "../../../../reducers/portalConfig";
import { connect } from "react-redux";


export const Overview = (props) => {
  const {
    classes,
    rateQuotaDetails,
    featureFlagDistributeRateLimit,
  } = props;

  const { getI18nMessage } = getI18n(useIntl());
  const rateLimitDetail = get(rateQuotaDetails, 'rateLimit');
  const distributedRateLimitDetail = get(rateQuotaDetails, 'distributedRateLimit');
  const quota = get(rateQuotaDetails, 'quota.quota') ?
    `${formatNumber(get(rateQuotaDetails, 'quota.quota'))} / ${capitalize(get(rateQuotaDetails, 'quota.interval'))}` : getI18nFormattedMessage('label.none');
  const description = get(rateQuotaDetails, 'description') ? get(rateQuotaDetails, 'description') : getI18nFormattedMessage('label.not.applicable');

  const perSecondText = getI18nMessage('label.rate.quota.per.seconds');
  const rateLimit =
      get(rateLimitDetail, 'maxRequestsPerSecond') ?
          `${formatNumber(get(rateLimitDetail, 'maxRequestsPerSecond'))} ${perSecondText}`
          : getI18nFormattedMessage('label.none');
  const rateLimitSpreadWindow =
      get(rateLimitDetail, 'windowSizeInSeconds') ?
          `${formatNumber(get(rateLimitDetail, 'windowSizeInSeconds'))} ${perSecondText}`
          : getI18nFormattedMessage('label.none');

  const distributedRateLimitInterval =
      get(distributedRateLimitDetail, 'interval') ? get(distributedRateLimitDetail, 'interval') : '';
  const distributedRateLimitIntervalObj =
      DISTRIBUTED_RATE_LIMIT_INTERVAL_API
        .find(value => value.uuid === distributedRateLimitInterval);

  return (
    <div
      id="rate-quota-details-overview-container"
      data-apim-test="rate-quota-details-overview-container"
    >
      <Grid container className={classes.marginPanelContainer}>
        <Grid item md={4} sm={12} xs={12} className={classes.paper}>
          <div className={classes.detailsContainer} data-apim-test="rate-quota-details-container">
            <Typography variant="h4">{getI18nFormattedMessage('label.rate.quota.rate.limit')}</Typography>
            <Typography variant="h5" className={classes.colTitle}>{getI18nFormattedMessage('label.rate.quota.rate.limit')} :</Typography>
            <div className={classes.detailsSubTitle}>{rateLimit}</div>
            <Typography variant="h5" className={classes.colTitle}>{getI18nFormattedMessage('label.rate.quota.spread.limit.window')} :</Typography>
            <div className={classes.detailsSubTitle}>{rateLimitSpreadWindow}</div>
            <Typography variant="h5" className={classes.colTitle}>{getI18nFormattedMessage('label.rate.quota.maximum.concurrency')} :</Typography>
            <div className={classes.detailsSubTitle}>{get(rateLimitDetail, 'maxConcurrency') ? formatNumber(get(rateLimitDetail, 'maxConcurrency')) : getI18nFormattedMessage('label.none')}</div>
            <Typography variant="h4">{getI18nFormattedMessage('label.rate.quota.limit.quota')}</Typography>
            <Typography variant="h5" className={classes.colTitle}>{getI18nFormattedMessage('label.rate.quota.limit.quota')}</Typography>
            <div className={classes.detailsSubTitle}>{quota}</div>
          </div>
        </Grid>
        <Grid item md={8} sm={12} xs={12} className={classes.paper}>
          <div className={classes.detailsContainer} data-apim-test="rate-quota-details-descriptions-container">
            {featureFlagDistributeRateLimit && (
              <React.Fragment>
                <Typography variant="h4">{getI18nFormattedMessage('label.rate.quota.distributed.rate.limit')}</Typography>
                <Typography variant="h5" className={classes.colTitle}>{getI18nFormattedMessage('label.rate.quota.distributed.rate.limit')} :</Typography>
                <div className={classes.detailsSubTitle}>{get(distributedRateLimitDetail, 'maxRequests') ? formatNumber(get(distributedRateLimitDetail, 'maxRequests')) : getI18nFormattedMessage('label.none')}</div>
                <Typography variant="h5" className={classes.colTitle}>{getI18nFormattedMessage('label.rate.quota.limit.distributed.rate.limit.interval')} :</Typography>
                <div className={classes.detailsSubTitle}>{distributedRateLimitIntervalObj ? distributedRateLimitIntervalObj.text : getI18nFormattedMessage('label.none')}</div>
                <Typography variant="h5" className={classes.colTitle}>{getI18nFormattedMessage('label.rate.quota.limit.distributed.burst')} :</Typography>
                <div className={classes.detailsSubTitle}>{get(distributedRateLimitDetail, 'burstLimit') ? formatNumber(get(distributedRateLimitDetail, 'burstLimit')) : getI18nFormattedMessage('label.none')}</div>
              </React.Fragment>
            )}
            <Typography variant="h4">{getI18nFormattedMessage('label.description')}</Typography>
            <div className={classes.detailsSubTitle}>{description}</div>
          </div>
        </Grid>
      </Grid>
      <Footer />
    </div>
  );
};

const mapStateToProps = (state) => ({
  featureFlagDistributeRateLimit: getFeatureFlagForDistributeRateLimit(state),
});

Overview.propTypes = {
  classes: shape({}),
  rateQuotaDetails: shape({}),
  featureFlagDistributeRateLimit: bool,
};
Overview.displayName = 'Overview';

export default compose(
  withStyles(styles),
  connect(mapStateToProps),
)(Overview);
